const MEANINGS: Record<string, string> = {
  missed: 'The planned time went by before the message could go out.',
  kill_switch: 'The lifecycle kill switch was off.',
  mode_off: 'The engine mode was off.',
  shadow: 'Planned and logged only.',
  quiet_hours: "It was outside the allowed hours in the worker's time zone.",
  holdout: 'The worker is in the holdout group, so gets no messages by design.',
  no_shifts_repeat: 'We already said there are no shifts nearby.',
  already_rated: 'The worker rated the shift before the reminder.',
  do_not_contact: 'Ops set do not contact on this worker.',
  missing_variable: "No copy variant could be filled with this worker's data.",
  no_channel: 'No SMS consent, no push device and no email allowed.',
  sms_disabled: "The journey's SMS switch is off.",
  sms_paused: 'SMS paused by itself after too many STOP replies.',
  goal_met: 'The worker reached the goal before the send.',
  link_failed: 'The tracked link could not be made.',
  tax_guide_missing:
    'No tax guide link is set. Set it in the Engine card, row "Tax guide link".',
};

export const reasonMeaning = (code: string, fallback: string) =>
  Object.prototype.hasOwnProperty.call(MEANINGS, code)
    ? MEANINGS[code]
    : fallback;
